// extracted by mini-css-extract-plugin
export default {"input":"FoodTitle_input__zh4Qn","hiddenDone":"FoodTitle_hiddenDone__jrRSb"};